import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const strengthComments180 = {
    "blockId": uuidv4(),
    "goalId": "commentsOnStrength",
    "isHiddenFromEditSurvey": true,
    "questions": [],
    "type": "priorityComments",
    "dimension": "commentsOnStrength"
}